import {
  SECTION_TRANSLATIONS,
  HELPER_TRANSLATIONS,
  LABEL_TRANSLATIONS,
} from '../../../translations';
import { formatDriversChartData } from './helpers';

/*******************************
 *
 * Generate drivers analysis chart node
 * @param {String} driversTitle of the drivers analysis chart
 * @param {Array} driversChartData drivers analysis chart data from drivers/drivers_analysis
 * @returns {Object} pigeondoc chart node
 *
 ******************************/
const driversChart = (driversTitle, driversChartData, includeLinks = true, lang) => {
  let combinedDrivers = [];
  if (driversChartData.num_drivers && driversChartData.num_drivers.length) {
    combinedDrivers = driversChartData.num_drivers;
    if (driversChartData.cat_drivers.length) {
      let concated = combinedDrivers.concat(driversChartData.cat_drivers);
      combinedDrivers = concated.sort((a, b) => {
        return b[0] - a[0];
      });
    }
  } else if (driversChartData.cat_drivers && driversChartData.cat_drivers.length) {
    combinedDrivers = driversChartData.cat_drivers;
  }

  let included_time_series = [];
  if (driversChartData['time_series_scores'] && driversChartData['time_series_scores'].length) {
    included_time_series = driversChartData['time_series_scores'];
  }

  const chartData = formatDriversChartData(combinedDrivers, includeLinks, included_time_series);
  let this_chart_type = 'horizontalBarChart';
  let x_label = LABEL_TRANSLATIONS.importance[lang];
  let y_label = LABEL_TRANSLATIONS.drivers[lang];
  if (included_time_series && included_time_series.length) {
    this_chart_type = 'horizontalLineChart';
    x_label = '';
    y_label = LABEL_TRANSLATIONS.importance[lang];
  }
  const chart = {
    type: this_chart_type,
    content: {
      title: `<span class='drivers-chart-heading' style='font-weight: 800'>${HELPER_TRANSLATIONS.driversChatTitle[lang]} ${driversTitle}</span>`,
      data: chartData,
    },
    id: 'drivers-top-chart',
    meta: {
      headingLevel: 'div',
      primaryBarColour: '#6A88AA',
      axisLabels: {
        x: x_label,
        y: y_label,
      },
      axisHoverText: {
        y: driversChartData.y_axis,
      },
    },
  };
  return chart;
};

const driversDescription = (driversChartData, lang) => {
  const str = SECTION_TRANSLATIONS.driversDetailsText[lang];
  const str1 = ` ${driversChartData.estimator_name.replace(/_/g, ' ') || 'regression'}. `;
  const str2 = driversChartData.dynamic_summary.drivers_summary;
  const driversDetailsText = str.concat(str1).concat(str2);

  return {
    type: 'text',
    content: driversDetailsText,
    id: 'drivers-top-details',
  };
};

const driversHeader = (driversTitle, lang) => {
  return {
    type: 'heading',
    content: `${driversTitle} ${LABEL_TRANSLATIONS.drivers[lang]}`,
    id: 'section-subtitle-drivers',
    meta: {
      headingLevel: 'h3',
      pdfConfig: {
        pageBreak: 'before',
      },
    },
  };
};

export { driversChart, driversDescription, driversHeader };
